import React, { useContext } from 'react'
import Topbar from '../Components/Topbar'
import Navbar from '../Components/Navbar'
import { apiValue } from '../Data/AllData'
import { CartProvider } from 'react-use-cart';
function AllProducts() {
    const data = useContext(apiValue);
  return (
    <CartProvider>
        <Topbar/>
        <Navbar/>
        <div className='section properties'>
          <div className='container'>
           <div className='row properties-box'>
            {data.map( (item)=>(
              <div className="col-lg-4 col-md-6 align-self-center mb-30 properties-items col-md-6 adv">
              <div className="item">
                <a href="property-details.html"><img src={item.images[0]} alt="" style={{height:"300px", width:"270px"}}/></a>
                <br/>
                <span className="category">{item.title}</span> 
                <h6>{item.price}&</h6>
                {/* <h4><a href="property-details.html">{item.category}</a></h4> */}
                <ul>
                  {/* <li>Brand: <span>{item.brand}</span></li> */}
                  <li>Rating: <span>{item.rating}</span></li>
                  <li>Stock: <span>{item.stock}</span></li>
                  <li>Sku: <span>{item.sku}</span></li>
                </ul>
                {/* <div className="main-button">
                  <a href="property-details.html">Schedule a visit</a>
                </div> */}
              </div>
            </div>
            ) )}
           </div>
          </div>
        </div>
    </CartProvider>
  )
}
export default AllProducts







//  <div className='section properties'>
// <div className='container'>
// <div className='row properties-box'>
//   {data.map( (item)=>(
//     <div className="col-lg-4 col-md-6 align-self-center mb-30 properties-items col-md-6 adv">
//     <div className="item">
//       <a href="property-details.html"><img src={item.images[0]} alt="" style={{height:"300px"}}/></a>
//       <span className="category">{item.title}</span>
//       <h6>${item.price}</h6>
//       <h4><a href="property-details.html">{item.category}</a></h4>
//       <ul>
//         <li>Brand: <span>{item.brand}</span></li>
//         <li     >Rating: <span>{item.rating}</span></li>
//         <li>Stock: <span>{item.stock}</span></li>
//         <li>Sku: <span>{item.sku}</span></li>
//       </ul>
//       <div className="main-button">
//         <a href="property-details.html">Schedule a visit</a>
//       </div>
//     </div>
//   </div>
//   ))}
// </div>
// </div>
// </div>



// <div>
              //   <h2>{item.title}</h2>
              //   <div className="main-button">
              //     <a href="property-details.html">Schedule a visit</a>
              //   </div>
              // </div>